module.exports = __webpack_public_path__ + "static/media/siddharth-wonderla-trip-04.b5e992c6.png";